import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineA = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M31 40H9C4.02944 40 0 35.9706 0 31V9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40Z",
			fill: "#FF1400"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.0419 30.5746L23.7215 26.5539H15.8892L14.5688 30.5746H9.94739L17.4489 9.35907H22.5214L30.053 30.5746H25.0419ZM20.78 17.4914C20.3303 16.1409 19.9707 14.4008 19.8805 13.6203H19.8204C19.7302 14.4008 19.3105 16.1409 18.8595 17.4914L17.0593 23.043H22.5802L20.78 17.4914Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLineA);
export { ForwardRef as ReactComponent };
